// extracted by mini-css-extract-plugin
export default {"csvTitle":"CsvHeader_csvTitle__PXWs0","checkIcon":"CsvHeader_checkIcon__TYCpV","correctIcon":"CsvHeader_correctIcon__Mu97K","wrongIcon":"CsvHeader_wrongIcon__SXE14"};